export enum RoleType {
    User = "User",
    Admin = "Admin",
    Owner = "Owner"
}
